module.exports = __webpack_public_path__ + "static/img/no_thumb.35bbf443.svg";